import styled from "styled-components";
import { SectionWrapper } from "shared/Styles/Wrappers";

export const Container = styled(SectionWrapper)`
    background-color: ${({ background }) => (background ? background : "#fff")};
    color: ${({ color }) => (color ? color : "#fff")};

    &.withPadding {
        padding: 60px 110px;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        &.withPadding {
            padding: 42px 84px;
        }
    }
    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.tablet_big}) {
        &.withPadding {
            padding: 24px 48px;
        }
    }
`;

export const Content = styled.div`

`;

export const VideoBox = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const Title = styled.h3`
    font-size: 2rem;
    line-height: 1;
    font-weight: 800;
    margin-bottom: 36px;

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        font-size: 1.8rem;
        margin-bottom: 24px;
    }
    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.tablet_big}) {
        font-size: 1.6rem;
    }
`;
